// trust
const handleClass = "relative flex w-px items-center justify-center bg-border after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 data-[direction=vertical]:h-px data-[direction=vertical]:w-full data-[direction=vertical]:after:left-0 data-[direction=vertical]:after:h-1 data-[direction=vertical]:after:w-full data-[direction=vertical]:after:-translate-y-1/2 data-[direction=vertical]:after:translate-x-0 [&[data-direction=vertical]>div]:rotate-90"

export default ({ direction }) => ({
  leftMinRatio: 20,
  leftDefaultRatio: 50,
  rightMinRatio: 40,
  rightDefaultRatio: 50,
  leftPanel: null,
  resizeHandle: null,
  rightPanel: null,
  init(){
    this.leftPanel = this.$el.children[0]
    this.resizeHandle = this.$el.children[1]
    this.rightPanel = this.$el.children[2]

    // set flexbox
    this.resizeHandle.classList = handleClass
    this.$el.style.display = 'flex'
    this.$el.style.height = '100%'
    this.$el.style.overflow = 'hidden'
    this.$el.style.width = '100%'
    this.leftPanel.style.overflow = 'hidden'
    this.rightPanel.style.overflow = 'hidden'

    // attrs/options
    this.leftMinRatio = this.leftPanel.dataset.minSize || 0
    this.rightMinRatio = this.rightPanel.dataset.minSize || 0
    this.leftDefaultRatio = this.leftPanel.dataset.defaultSize || 50
    this.rightDefaultRatio = this.rightPanel.dataset.defaultSize || 50
    if(direction == 'vertical'){
      this.resizeHandle.dataset.direction = 'vertical'
      this.$el.style.flexDirection = 'column'
    }

    // default split
    this.leftPanel.style.flex = `${this.leftDefaultRatio} 1 0px`
    this.rightPanel.style.flex = `${this.rightDefaultRatio} 1 0px`

    // disable select on handle
    this.resizeHandle.style.touchAction = 'none'
    this.resizeHandle.style.userSelect = 'none'
    this.resizeHandle.style.cursor = direction == 'vertical' ? 'row-resize' : 'col-resize'

    this.resizeHandle.addEventListener('mousedown', () => this.resizer())
  },
  resizer() {
    const containerWidth = this.$el.getBoundingClientRect().width
    const containerHeight = this.$el.getBoundingClientRect().height

    this.$el.style.cursor = direction == 'vertical' ? 'row-resize' : 'col-resize'

    const onMousemove = (e) => {
      const movement = direction == 'vertical' ? (100 * e.movementY / containerHeight) : (100 * e.movementX / containerWidth)
      const currentLeftRatio = parseFloat(this.leftPanel.style.flex.split(/\s/)[0])
      const currentRightRatio = parseFloat(this.rightPanel.style.flex.split(/\s/)[0])
      const newLeftRatio = currentLeftRatio + movement
      const newRightRatio = currentRightRatio - movement

      const handleXpos  = direction == 'vertical' ? this.resizeHandle.getBoundingClientRect().y : this.resizeHandle.getBoundingClientRect().x
      const mouseXpos   = direction == 'vertical' ? e.clientY : e.clientX
      const isMoving    = (movement > 0 && mouseXpos >= handleXpos) || (movement < 0 && mouseXpos <= handleXpos)
      const isInBounds = newLeftRatio >= this.leftMinRatio && newRightRatio >= this.rightMinRatio

      if(isMoving && isInBounds){
        this.leftPanel.style.flex = `${newLeftRatio} 1 0px`
        this.rightPanel.style.flex = `${newRightRatio} 1 0px`
      }
    }

    const onMouseup = (e) => {
      window.removeEventListener('mousemove', onMousemove)
      window.removeEventListener('mouseup', onMouseup)

      this.$el.style.cursor = 'default'
    }

    window.addEventListener('mousemove', onMousemove)
    window.addEventListener('mouseup', onMouseup)
  }
})